<template>
  <div class="flex w-full h-auto">
    <div class="relative mt-1">
      <div
        @click="toggleShowOptions"
        class="h-full flex items-center gap-5 cursor-pointer"
      >
        <span class="font-normal text-sm text-black-10">{{
          form.transactionOption
        }}</span>
        <arrow-icon
          class="transform transition duration-300"
          :class="showOptions ? '-rotate-180' : 'rotate-0'"
        />
      </div>

      <div v-show="showOptions" class="box">
        <span
          v-for="(transaction, index) in filteredTransactionOptions"
          :key="index"
          :class="activeOption(transaction.name)"
          @click="handleChange(transaction)"
        >
          {{ transaction.name }}
        </span>
      </div>
    </div>

    <div
      v-show="showOptions"
      @click="toggleShowOptions"
      class="fixed inset-0 h-full w-full"
    ></div>
  </div>
</template>

<script>
import tenant from '@/mixins/tenant.js'
import getTransactions from '@/mixins/transactions.js'

export default {
  mixins: [tenant, getTransactions],
  components: {
    ArrowIcon: () => import('@/assets/v2/icons/ArrowDownTwo.vue')
  },
  data () {
    return {
      showOptions: false,
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: ''
      },
      form: {
        transactionOption: 'Holding Transactions'
      }
    }
  },
  methods: {
    activeOption (option) {
      return this.form.transactionOption === option
        ? 'bg-secondary-2 text-primary font-bold'
        : 'text-gray-10 hover:bg-gray-100 font-normal'
    },
    toggleShowOptions () {
      this.showOptions = !this.showOptions
    },
    handleChange (selectedFilter) {
      this.form.transactionOption = selectedFilter.name
      this.showOptions = false
      this.updateTransactionType(selectedFilter.value)
    },
    updateTransactionType (filter) {
      this.$store.dispatch('transactions/activeFilter', filter)
      this.payload.page = 1
      this.payload.type = filter !== 'all' ? filter : ''
      this.isLoadingTransactions = true
      this.getTransactions()
    },
    updateTransactionOption () {
      let filterOption = this.$store?.state?.transactions?.activeFilter
      if (filterOption === this.$transactionType.DEPOSIT) {
        filterOption = 'Holding Transactions'
      }
      this.form.transactionOption = filterOption
    }
  },
  mounted () {
    this.updateTransactionOption()
  }
}
</script>

<style scoped>
.box {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 150%;
  width: 165px;
  min-width: 100%;
  padding: 4px 0;
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 16px 24px 0px #0302071f;
  border: 1px solid #eae9e9;
  z-index: 2;

  span {
    cursor: pointer;
    padding: 4px 13px;
    font-size: 13px;
  }
}
>>> .el-input__inner {
  border: none !important;
  color: var(--foreground-default);
  height: auto !important;
}
</style>
